// extracted by mini-css-extract-plugin
export default {"kpiCard":"styles_kpiCard__RlkZU","wrapper":"styles_wrapper__+3vdi","pIcon":"styles_pIcon__lEgXk","pLabel":"styles_pLabel__Ton6e"};